module.exports = __webpack_public_path__ + "assets/img/postbar.c218e77e.png";